<app-rc-dialog-wrapper (closePopin)="onAction(PopinButtonActionEnum.CLEAR)">
  <div class="popin__wrapper">
    <div class="popin">
      <div class="popin__header">
        <h3 class="popin__title">{{ data?.title }}</h3>
      </div>
      <div class="popin__content">
        <p class="popin__subtitle">{{ data?.subTitle }}</p>
      </div>
      <div class="popin__actions">
        <div class="popin__actions__wrapper">
          @for (buttonAction of buttons; track buttonAction; let i = $index) {
            @if (data.buttons[buttonAction]?.style === PopinButtonStyle.LINK) {
              <rc-link
                data-qa="vs-exit-popin-button-secondary-action"
                variant="secondary"
                size="large"
                [class]="'popin__actions__button--' + buttonAction"
                [disabled]="data.buttons[buttonAction]?.status === PopinButtonStatus.DISABLED"
                (click)="onAction(buttonAction)"
              >
                @if (data.buttons[buttonAction]?.status === PopinButtonStatus.LOADING) {
                  <app-icon class="spinner disabled" [name]="IconName.spinner_circle"></app-icon>
                } @else {
                  {{ data.buttons[buttonAction]?.name }}
                }
              </rc-link>
            } @else {
              <rc-button
                data-qa="vs-exit-popin-button-primary-action"
                [attr.variant]="buttonsClass[data.buttons[buttonAction]?.style]"
                [class]="'popin__actions__button--' + buttonAction"
                [disabled]="data.buttons[buttonAction]?.status === PopinButtonStatus.DISABLED"
                (click)="onAction(buttonAction)"
              >
                @if (data.buttons[buttonAction]?.status === PopinButtonStatus.LOADING) {
                  <app-icon class="spinner disabled" [name]="IconName.spinner_circle"></app-icon>
                } @else {
                  {{ data.buttons[buttonAction]?.name }}
                }
              </rc-button>
            }

            @if (i === 0 && buttons.length === 2) {
              <span class="popin__actions__separator" i18n="@@action_separator">or</span>
            }
          }
        </div>
      </div>
    </div>
  </div>
</app-rc-dialog-wrapper>
